import { useEffect, useState } from "react";

export function useRTLDirection(chatConfig?: Record<string, any>) {
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    const direction = chatConfig?.direction;
    const isRightToLeft = direction === "rtl";
    setIsRTL(isRightToLeft);
    if (typeof document !== "undefined") {
      const livebotRoot = document.querySelector(".livebot_root");
      if (livebotRoot) {
        livebotRoot.setAttribute("dir", isRightToLeft ? "rtl" : "ltr");
      }
    }
  }, [chatConfig?.direction]);

  return {
    isRTL,
    direction: isRTL ? "rtl" : "ltr",
    dirClass: isRTL ? "rtl" : "ltr",
    marginStart: isRTL ? "mr" : "ml",
    marginEnd: isRTL ? "ml" : "mr",
    paddingStart: isRTL ? "pr" : "pl",
    paddingEnd: isRTL ? "pl" : "pr",
    textAlign: {
      start: isRTL ? "text-right" : "text-left",
      end: isRTL ? "text-left" : "text-right",
    },
    float: {
      start: isRTL ? "float-right" : "float-left",
      end: isRTL ? "float-left" : "float-right",
    },
    position: {
      start: isRTL ? "right" : "left",
      end: isRTL ? "left" : "right",
    },
  };
}
